module.exports = __webpack_public_path__ + "img/icon-payment-success.38335d7c.png";